import { action } from "@ember/object"
import Component from "@glimmer/component"
import styles from "./single-button-row.module.css"

interface Sig {
  Element: HTMLDivElement
  Args: {
    clickAction: () => void
    closeMenu?: () => void
    isAtTopOfMenu?: boolean
    isDisabled?: boolean
    isSecondary?: boolean
    iconName?: string
  }
  Blocks: {
    default?: any
  }
}

export default class SingleButtonRow extends Component<Sig> {
  readonly styles = styles

  @action onClick() {
    if (this.args.clickAction) {
      this.args.clickAction()
    }
    if (this.args.closeMenu) {
      this.args.closeMenu()
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "DS::DropdownMenu::SingleButtonRow": typeof SingleButtonRow
  }
}
